export default [
  {
    path: "/reservations",
    name: "reservations",
    component: () => import("../components/modules/reservation/ReservationList.vue"),
  },
];
